(() => {
  if (window.customProductMobileGalleryDotsV1) return;
  window.customProductMobileGalleryDotsV1 = true;
  const initialize = () => document.querySelectorAll('[data-custom-desktop-gallery-v1]').forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const track = viewer?.querySelector('.product__media-list');
    if (track && !gallery.parentElement.querySelector(':scope > .custom-product-mobile-zoom-v1')) {
      const originalIcon = track.querySelector('.product__media-icon--lightbox');
      if (originalIcon) {
        const zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'custom-product-mobile-zoom-v1';
        zoom.setAttribute('aria-label', 'Enlarge current product photo');
        zoom.setAttribute('aria-haspopup', 'dialog');
        zoom.innerHTML = originalIcon.innerHTML;
        const currentItem = () => {
          const left = track.getBoundingClientRect().left;
          return [...track.querySelectorAll(':scope > .product__media-item')]
            .filter((item) => item.getBoundingClientRect().width > 0)
            .sort((a, b) => Math.abs(a.getBoundingClientRect().left - left) - Math.abs(b.getBoundingClientRect().left - left))[0];
        };
        const updateZoom = () => {
          if (matchMedia('(min-width: 750px)').matches) return;
          zoom.hidden = !currentItem()?.querySelector('.product__media-icon--lightbox');
        };
        zoom.addEventListener('click', () => currentItem()?.querySelector('.product__modal-opener--image .product__media-toggle')?.click());
        gallery.parentElement.append(zoom);
        track.addEventListener('scroll', updateZoom, { passive: true });
        new ResizeObserver(updateZoom).observe(track);
        updateZoom();
      }
    }
    if (!track || viewer.querySelector('.custom-product-mobile-gallery-dots-v1')) return;
    const items = [...track.querySelectorAll(':scope > .product__media-item')].filter((e) => getComputedStyle(e).display !== 'none' || !e.classList.contains('product__media-item--variant'));
    if (items.length < 2) return;
    const dots = document.createElement('div');
    dots.className = 'custom-product-mobile-gallery-dots-v1';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Product photos');
    let selected = 0;
    const select = (index) => {
      const target = items[index];
      if (!target) return;
      gallery.setActiveMedia(target.dataset.mediaId, false);
      track.scrollTo({ left: target.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    for (let index = 0; index < Math.min(4, items.length); index++) {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Show photo ${index + 1}`);
      button.innerHTML = '<span aria-hidden="true"></span>';
      button.addEventListener('click', () => select(index));
      dots.append(button);
    }
    if (items.length >= 4) {
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'custom-product-mobile-gallery-more-v1';
      more.textContent = '+';
      more.setAttribute('aria-label', 'View more product photos');
      more.addEventListener('click', () => select((selected + 1) % items.length));
      dots.append(more);
    }
    const update = () => {
      if (matchMedia('(min-width: 750px)').matches) return;
      const box = track.getBoundingClientRect();
      selected = items.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().left - box.left) < Math.abs(items[best].getBoundingClientRect().left - box.left) ? index : best, 0);
      [...dots.children].forEach((button, index) => button.setAttribute('aria-current', String(index === selected || (selected >= 4 && index === 4))));
    };
    viewer.append(dots);
    track.addEventListener('scroll', update, { passive: true });
    viewer.addEventListener('slideChanged', update);
    new ResizeObserver(update).observe(track);
    update();
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; initialize(); });
  }).observe(document.body, { childList: true, subtree: true });
  initialize();
})();
